'use client';

import { useState, useEffect } from 'react';
interface TableEmbedProps {
  data: {
    content: string;
    'content-type': string;
  };
}
export default function TableEmbed({
  data
}: TableEmbedProps) {
  const [tableData, setTableData] = useState<string[][]>([]);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    try {
      if (data && data.content && data['content-type'] === 'csv') {
        // Parse CSV content
        const lines = data.content.split('\r\n').filter(line => line.trim());
        const parsedData: string[][] = [];
        for (const line_0 of lines) {
          // Handle quoted fields and regular CSV parsing
          const row: string[] = [];
          let currentField = '';
          let inQuotes = false;
          for (let i = 0; i < line_0.length; i++) {
            const char = line_0[i];
            if (char === '"') {
              inQuotes = !inQuotes;
            } else if (char === ',' && !inQuotes) {
              row.push(currentField.trim());
              currentField = '';
            } else {
              currentField += char;
            }
          }

          // Add the last field
          row.push(currentField.trim());
          parsedData.push(row);
        }
        setTableData(parsedData);
      }
    } catch (err) {
      console.error('TableEmbed: Error parsing CSV', err);
      setError('Failed to parse table data');
    }
  }, [data]);
  if (error) {
    return <div className="mb-4 p-4 border border-red-300 bg-red-50 rounded">
        <p className="text-red-600">Error loading table: {error}</p>
      </div>;
  }
  if (tableData.length === 0) {
    return <div className="mb-4 p-4 border border-gray-300 bg-gray-50 rounded">
        <p className="text-gray-600">Loading table...</p>
      </div>;
  }
  return <div className="mb-4 overflow-x-auto">
      <table className="min-w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            {tableData[0]?.map((header, index) => <th key={index} className="border border-gray-300 px-4 py-2 text-left text-14-tamil-600 font-semibold text-1B1B1B">
                {header}
              </th>)}
          </tr>
        </thead>
        <tbody>
          {tableData.slice(1).map((row_0, rowIndex) => <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
              {row_0.map((cell, cellIndex) => <td key={cellIndex} className="border border-gray-300 px-4 py-2 text-14-tamil-500 text-4D4D4D">
                  {cell}
                </td>)}
            </tr>)}
        </tbody>
      </table>
    </div>;
}